import React,{useState} from "react";
import toast, { Toaster } from "react-hot-toast";
import { useHomeContext } from "../../context/HomeContext";
import { useAuth } from "../../context/auth";
import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { ThreeDots } from "react-loader-spinner";
import { Tab } from '@headlessui/react'
import { useNavigate } from "react-router-dom";
import UpdateProfile from "./components/UpdateProfile";
import UpdateCompany from "./components/UpdateCompany";
import { useThemeContext } from "../../context/ThemeContext";
const Profile = () => {
  const { token, user } = useAuth();
  const {currentMode,setCurrentMode} = useThemeContext()
  const navigate = useNavigate();
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };
  const profileData = useQuery(
    ["profileDataApi"],
    async () =>
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}user/profile/${user.companyId}`,
        {
          headers,
        }
      ),
    {
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token,
      onSuccess: (res) => {},
    }
  );
  console.log(profileData?.data?.data?.data?.company?.logo);
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }
  const [categories] = useState(['profile','Company','three'])
  
  return (
    <div className="p-3 md:p-10">
      <div className="flex items-center justify-between pb-3">
      <h1 className=" text-dark-color dark:text-white  font-semibold text-xl">
          Dashboard / Profile
        </h1>
      </div>
      <div className=" grid grid-cols-1 md:grid-cols-2 gap-3  ">
        <div className=" bg-white dark:bg-secondary-dark-bg w-full p-5 rounded-2xl">
          <div className=" flex items-start space-x-5 w-full">
            <img
              src={profileData?.data?.data?.data?.user?.profile}
              className=" rounded-full h-20 w-20 object-contain"
            />
            <div className="w-full  flex flex-col items-start space-y-1 ">
              <h1 className="font-medium text-main-color text-xl">Personal Information</h1>
             <div className="max-w-xs flex items-center space-x-5 w-full">
              <h1 className="font-medium text-dark-color">Name:</h1>
              <h1 className="font-medium text-dark-gray text-sm">
                {profileData?.data?.data?.data?.user?.firstName +
                  " " +
                  profileData?.data?.data?.data?.user?.lastName}
              </h1>
             </div>
             <div className="max-w-xs flex items-center space-x-5 w-full">
              <h1 className="font-medium text-dark-color">Email:</h1>
              <h1 className="font-medium text-dark-gray text-sm">
                {profileData?.data?.data?.data?.user?.email}
              </h1>
             </div>
             <div className="max-w-xs flex items-center space-x-4 w-full">
              <h1 className="font-medium text-dark-color">Phone:</h1>
              <h1 className="font-medium text-dark-gray text-sm">
                {profileData?.data?.data?.data?.user?.phone}
              </h1>
             </div>
            </div>
          </div>
        </div>
        <div className=" bg-white dark:bg-secondary-dark-bg w-full p-5 rounded-2xl">
          <div className=" flex flex-col md:flex-row items-start space-x-5 w-full">
            <img
              src={profileData?.data?.data?.data?.company?.logo}
              className=" rounded-md h-28 w-28 object-contain"
            />
            <div className=" flex flex-col items-start space-y-1 ">
            <h1 className="font-medium text-main-color text-xl">Company Information</h1>
            <div className="max-w-xs flex items-center space-x-5 w-full">
              <h1 className="font-medium text-dark-color">Company:</h1>
             <h1 className="font-medium text-main-color">
                {profileData?.data?.data?.data?.company?.name}
              </h1>
             </div>
             <div className="max-w-xs flex items-center space-x-10 w-full">
              <h1 className="font-medium text-dark-color">phone:</h1>
              <h1 className="font-medium text-dark-gray text-sm">
                {profileData?.data?.data?.data?.company?.phoneNo}
              </h1>
             </div>
             <div className="max-w-xs flex items-center space-x-10 w-full">
              <h1 className="font-medium text-dark-color">Address:</h1>
              <h1 className="font-medium text-dark-gray text-sm">
                {profileData?.data?.data?.data?.company?.address}
              </h1>
             </div>
            </div>
          </div>
        </div>
      </div>
      {/*  */}
      <div className="grid grid-cols-1 md:grid-cols-12 gap-3 py-5">
      <div className="md:col-span-4 bg-white dark:bg-secondary-dark-bg p-5 rounded-2xl">
         <div className="flex items-center justify-between">
          <div className="flex flex-col items-center justify-center">
            <h1 className="text-dark-color font-bold text-2xl">250</h1>
            <p  className="text-dark-gray text-light text-sm">properties</p>
          </div>
          <div className="flex flex-col items-center justify-center">
            <h1 className="text-dark-color font-bold text-2xl">250</h1>
            <p className="text-dark-gray text-light text-sm">properties</p>
          </div>
          <div className="flex flex-col items-center justify-center">
            <h1 className="text-dark-color font-bold text-2xl">250</h1>
            <p className="text-dark-gray text-light text-sm">properties</p>
          </div>
         </div>
      </div>
      {/*  */}
      <div className="md:col-span-8 bg-white dark:bg-secondary-dark-bg p-2 md:p-5 rounded-2xl">
      <div className="w-full  px-2  sm:px-0">
      <Tab.Group>
        <Tab.List className="flex space-x-1 rounded-xl  p-1">
          {categories.map((category) => (
            <Tab
              key={category}
              className={({ selected }) =>
                classNames(
                  'w-full  py-2.5 text-sm font-medium leading-5 text-[#216fed]',
                  ' text-gray-700   focus:outline-none ',
                  selected
                    ? ' border-b border-blue-500 hover:border-blue-500'
                    : 'text-gray-700 border-b duration-500 ease-in-out hover:border-blue-500 '
                )
              }
            >
              {category}
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels className={'text-red-500'}>
        <Tab.Panel><UpdateProfile /></Tab.Panel>
        <Tab.Panel><UpdateCompany /></Tab.Panel>
        <Tab.Panel>Content 3</Tab.Panel>
      </Tab.Panels>
      </Tab.Group>
    </div>
      </div>
      </div>
    </div>
  );
};

export default Profile;
